module.exports = __webpack_public_path__ + "img/CH00-000-001.f11c36ea.jpg";